'use client';

import ColdCallsPage from '@/views/products/cold-calls';

export default ColdCallsPage;
